import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';

const useDeleteCompany = (companyId: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutationApi<void, void>({
    endpoint: `core/companies/${companyId}`,
    method: 'DELETE',
    successMessage: 'Company deleted successfully',
    errorMessage: 'Failed to delete company',
    options: {
      onSuccess: () => {
        // Invalidate the specific company query
        void queryClient.invalidateQueries({
          queryKey: [`core/companies/${companyId}`],
        });

        // Invalidate all paginated companies queries to refresh the list
        void queryClient.invalidateQueries({
          queryKey: ['companies', 'paginated'],
        });

        // Call the optional user-provided onSuccess callback
        if (onSuccess) {
          onSuccess();
        }
      },
    },
  });
};

export default useDeleteCompany;
